export const getLocalDateInputValue = (now = new Date()) => {
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const getSeverityLevel = (value, warningThreshold, dangerThreshold) => {
    const numericValue = Number(value) || 0;
    if (numericValue > dangerThreshold) return 'danger';
    if (numericValue > warningThreshold) return 'warning';
    return 'normal';
};

export const getHighestSeverity = (...levels) => {
    if (levels.includes('danger')) return 'danger';
    if (levels.includes('warning')) return 'warning';
    return 'normal';
};

export const formatAverageInterval = (seconds) => {
    const roundedSeconds = Math.round(Number(seconds) || 0);
    const roundedMinutes = Math.round(roundedSeconds / 60);
    const minuteLabel = roundedMinutes === 1 ? 'min' : 'mins';
    return `${roundedSeconds}s (${roundedMinutes} ${minuteLabel})`;
};

export const getAgentSeverity = (agent = {}) => {
    const idleSeverity = getSeverityLevel(agent['Total Idle Minutes (>=5)'], 60, 80);
    const intervalSeverity = getSeverityLevel(agent['Avg Call Interval (sec)'], 120, 240);
    return getHighestSeverity(idleSeverity, intervalSeverity);
};

export const getAgentStatusClass = (agent = {}) => {
    if (!agent['Has Any Calls']) return 'no-calls';
    const severity = getAgentSeverity(agent);
    if (severity === 'danger') return 'high-idle';
    if (severity === 'warning') return 'warning-idle';
    return 'ok';
};

export const getAgentStatusText = (agent = {}) => {
    if (!agent['Has Any Calls']) return 'No Calls';
    const severity = getAgentSeverity(agent);
    if (severity === 'danger') return 'High Idle';
    if (severity === 'warning') return 'Watch Idle';
    return 'OK';
};
